




































































import { Component, Vue } from 'vue-property-decorator';
import Home from '@/pages/Home.vue'

@Component({ components: { Home } })
export default class NavMenu extends Vue {

    private isCollapse: boolean = false;

    onToggle() {
        this.isCollapse = !this.isCollapse;
    }

    onCommand(command: string) {
        switch (command) {
            case "info":
                this.$router.push("/my/info");
                break;
            case "pwd":
                this.$router.push("/my/password");
                break;
            case "logout":
                this.$store.state.token = null;
                this.$router.push("/login");
                break;
        }
    }
}
